import { createFileRoute } from '@tanstack/react-router';
import { toolHead } from '../../../lib/toolHead';
import { ProfileViewerPage } from '../../../pages/tools/creator-tools/ProfileViewerPage';

export const Route = createFileRoute('/_site/tools/profile-viewer')({
  head: () => toolHead('profile-viewer'),
  component: ProfileViewerPage,
});
